var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "b-card",
        [
          _c(
            "b-card-body",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "d-flex justify-content-end",
                      attrs: { md: "12" },
                    },
                    [
                      _vm.IsAdmin()
                        ? _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "b-modal",
                                  rawName: "v-b-modal.addModal",
                                  modifiers: { addModal: true },
                                },
                              ],
                              attrs: { variant: "primary" },
                            },
                            [
                              _c("feather-icon", {
                                staticClass: "mr-50",
                                attrs: { icon: "PlusIcon" },
                              }),
                              _vm._v(" Import Attendance "),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.IsAdmin()
                        ? _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "b-modal",
                                  rawName: "v-b-modal.modal-add-attendance",
                                  modifiers: { "modal-add-attendance": true },
                                },
                              ],
                              staticClass: "ml-2",
                              attrs: { variant: "primary" },
                            },
                            [
                              _c("feather-icon", {
                                staticClass: "mr-50",
                                attrs: { icon: "PlusIcon" },
                              }),
                              _vm._v(" Add Attendance "),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "my-1", attrs: { md: "2", sm: "4" } },
                    [
                      _c(
                        "b-form-group",
                        { staticClass: "mb-0" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "d-inline-block text-sm-left mr-50",
                            },
                            [_vm._v("Per page")]
                          ),
                          _c("b-form-select", {
                            staticClass: "w-50",
                            attrs: {
                              id: "perPageSelect",
                              size: "sm",
                              options: _vm.pageOptions,
                            },
                            model: {
                              value: _vm.perPage,
                              callback: function ($$v) {
                                _vm.perPage = $$v
                              },
                              expression: "perPage",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-table", {
                        attrs: {
                          striped: "",
                          hover: "",
                          responsive: "",
                          "per-page": _vm.perPage,
                          "sort-by": _vm.sortBy,
                          "sort-desc": _vm.sortDesc,
                          "sort-direction": _vm.sortDirection,
                          "current-page": _vm.currentPage,
                          items: _vm.filteredAttendance,
                          fields: _vm.attendance_fields,
                          filter: _vm.filter,
                          "filter-included-fields": _vm.filterOn,
                        },
                        on: {
                          "update:sortBy": function ($event) {
                            _vm.sortBy = $event
                          },
                          "update:sort-by": function ($event) {
                            _vm.sortBy = $event
                          },
                          "update:sortDesc": function ($event) {
                            _vm.sortDesc = $event
                          },
                          "update:sort-desc": function ($event) {
                            _vm.sortDesc = $event
                          },
                          filtered: _vm.onFiltered,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "cell(employeeName)",
                            fn: function (data) {
                              return [
                                _vm._v(
                                  " " + _vm._s(data.item.employeeName) + " "
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(date)",
                            fn: function (data) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.convertTimestampToDate(data.item.date)
                                    ) +
                                    " "
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(clockInTime)",
                            fn: function (data) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.convertTimestampToTime(
                                        data.item.clockInTime
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(clockOutTime)",
                            fn: function (data) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.convertTimestampToTime(
                                        data.item.clockOutTime
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(hoursWorked)",
                            fn: function (data) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.getHoursWorked(
                                        data.item.clockInTime,
                                        data.item.clockOutTime
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(status)",
                            fn: function (data) {
                              return [
                                !data.item.editingStatus
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-items-center",
                                        on: {
                                          click: function ($event) {
                                            return _vm.editStatusField(
                                              data.item,
                                              "editingStatus"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "b-badge",
                                          {
                                            attrs: {
                                              variant: _vm.getStatusColor(
                                                data.item.status
                                              ),
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(data.item.status) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _vm.IsAdmin()
                                          ? _c("feather-icon", {
                                              staticClass: "ml-2",
                                              attrs: { icon: "EditIcon" },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _c(
                                      "div",
                                      [
                                        _c("b-form-select", {
                                          attrs: {
                                            disabled: !_vm.IsAdmin(),
                                            options: _vm.statusOptions,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.saveStatusField(
                                                data.item,
                                                "editingStatus"
                                              )
                                            },
                                          },
                                          model: {
                                            value: data.item.status,
                                            callback: function ($$v) {
                                              _vm.$set(data.item, "status", $$v)
                                            },
                                            expression: "data.item.status",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                              ]
                            },
                          },
                          {
                            key: "cell(notes)",
                            fn: function (data) {
                              return [
                                !data.item.editingRemarks
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-items-center",
                                        on: {
                                          click: function ($event) {
                                            return _vm.editRemarkField(
                                              data.item,
                                              "editingRemarks"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(_vm._s(data.item.notes)),
                                        ]),
                                        _vm.IsAdmin()
                                          ? _c("feather-icon", {
                                              staticClass: "ml-2",
                                              attrs: { icon: "EditIcon" },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _c(
                                      "div",
                                      [
                                        _c("b-form-input", {
                                          attrs: { disabled: !_vm.IsAdmin() },
                                          on: {
                                            blur: function ($event) {
                                              return _vm.saveRemarkField(
                                                data.item,
                                                "editingRemarks"
                                              )
                                            },
                                          },
                                          model: {
                                            value: data.item.notes,
                                            callback: function ($$v) {
                                              _vm.$set(data.item, "notes", $$v)
                                            },
                                            expression: "data.item.notes",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                              ]
                            },
                          },
                          {
                            key: "cell(actions)",
                            fn: function () {
                              return [
                                _c(
                                  "b-dropdown",
                                  {
                                    staticClass: "m-1",
                                    attrs: {
                                      variant: "link",
                                      "toggle-class": "p-0",
                                      "no-caret": "",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "button-content",
                                        fn: function () {
                                          return [
                                            _c("feather-icon", {
                                              staticClass:
                                                "align-middle text-body",
                                              attrs: {
                                                icon: "MoreVerticalIcon",
                                                size: "16",
                                              },
                                            }),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ]),
                                  },
                                  [
                                    _vm.IsAdmin()
                                      ? _c(
                                          "b-dropdown-item",
                                          {
                                            directives: [
                                              {
                                                name: "b-modal",
                                                rawName:
                                                  "v-b-modal.modal-edit-timesheet",
                                                modifiers: {
                                                  "modal-edit-timesheet": true,
                                                },
                                              },
                                            ],
                                          },
                                          [
                                            _c("feather-icon", {
                                              attrs: { icon: "EditIcon" },
                                            }),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "align-middle ml-50",
                                              },
                                              [_vm._v("Edit")]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-modal",
                    {
                      attrs: {
                        id: "addModal",
                        title: "Import Attendance",
                        "cancel-title": "Close",
                        "hide-footer": "",
                        centered: "",
                      },
                      on: { hidden: _vm.resetForm },
                      model: {
                        value: _vm.showAddModal,
                        callback: function ($$v) {
                          _vm.showAddModal = $$v
                        },
                        expression: "showAddModal",
                      },
                    },
                    [
                      _c(
                        "b-form",
                        {
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                              return _vm.ImportAttendance($event)
                            },
                          },
                        },
                        [
                          _c("b-row", [
                            _c(
                              "div",
                              { staticClass: "m-4" },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Upload File",
                                      "label-for": "file-input ",
                                    },
                                  },
                                  [
                                    _c("b-form-file", {
                                      attrs: {
                                        id: "file-input",
                                        placeholder:
                                          "Choose a file or drop it here...",
                                        "drop-placeholder": "Drop file here...",
                                      },
                                      model: {
                                        value: _vm.file,
                                        callback: function ($$v) {
                                          _vm.file = $$v
                                        },
                                        expression: "file",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c("b-card-text", { staticClass: "my-1" }, [
                                  _vm._v(" Selected file: "),
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.file
                                          ? _vm.file.name
                                          : "No file selected"
                                      )
                                    ),
                                  ]),
                                ]),
                              ],
                              1
                            ),
                          ]),
                          _c(
                            "div",
                            { staticClass: "d-flex justify-content-end" },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "mr-2",
                                  attrs: { variant: "info" },
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "text-white",
                                      attrs: {
                                        href:
                                          "/csv/" +
                                          _vm.csvFiles["Attendance Data"],
                                        download: "",
                                        target: "_blank",
                                      },
                                    },
                                    [
                                      _c("feather-icon", {
                                        attrs: { icon: "EyeIcon" },
                                      }),
                                      _vm._v(" View Format "),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _c(
                                "b-button",
                                {
                                  staticClass: "mr-2",
                                  attrs: { variant: "secondary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.closeImportmodal()
                                    },
                                  },
                                },
                                [_vm._v("Cancel")]
                              ),
                              _c(
                                "b-button",
                                {
                                  attrs: { type: "button", variant: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.ImportAttendance()
                                    },
                                  },
                                },
                                [_vm._v("Submit")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-modal",
                    {
                      ref: "modalAddAttendance",
                      attrs: {
                        id: "modal-add-attendance",
                        title: "Add Attendance",
                        "hide-footer": "",
                        centered: "",
                      },
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.addAttendance($event)
                        },
                      },
                    },
                    [
                      _c("validation-observer", {
                        ref: "addAttendanceForm",
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var invalid = ref.invalid
                              return [
                                _c(
                                  "b-form",
                                  {
                                    on: {
                                      submit: function ($event) {
                                        $event.preventDefault()
                                        return _vm.addAttendance($event)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Employee Name*",
                                          "label-for": "name",
                                        },
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: "Employee Name",
                                            rules: "required",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("b-form-select", {
                                                      attrs: {
                                                        id: "name",
                                                        "value-field": "id",
                                                        "text-field":
                                                          "fullName",
                                                        options:
                                                          _vm.formattedEmployeeOptions,
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          return _vm.employeeSelected(
                                                            _vm.employeeId
                                                          )
                                                        },
                                                      },
                                                      model: {
                                                        value: _vm.employeeId,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.employeeId = $$v
                                                        },
                                                        expression:
                                                          "employeeId",
                                                      },
                                                    }),
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Date",
                                          "label-for": "date",
                                        },
                                      },
                                      [
                                        _c("b-form-datepicker", {
                                          staticClass: "mt-1",
                                          attrs: {
                                            placeholder: "Select Date",
                                            size: "sm",
                                            "date-format-options": {
                                              year: "numeric",
                                              month: "2-digit",
                                              day: "2-digit",
                                            },
                                          },
                                          on: {
                                            input: function ($event) {
                                              _vm.currentPage = 1
                                            },
                                          },
                                          model: {
                                            value: _vm.newAttendance.date,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.newAttendance,
                                                "date",
                                                $$v
                                              )
                                            },
                                            expression: "newAttendance.date",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Clock In Time*",
                                          "label-for": "clockintime",
                                        },
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: "Clock In Time",
                                            rules: "required",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("b-form-timepicker", {
                                                      attrs: {
                                                        id: "clockintime",
                                                        min: new Date(),
                                                        locale: "en",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.newAttendance
                                                            .clockintime,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.newAttendance,
                                                            "clockintime",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "newAttendance.clockintime",
                                                      },
                                                    }),
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Clock Out Time*",
                                          "label-for": "clockouttime",
                                        },
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: "Clock Out Time",
                                            rules: "required",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("b-form-timepicker", {
                                                      attrs: {
                                                        id: "clockouttime",
                                                        min: new Date(),
                                                        locale: "en",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.newAttendance
                                                            .clockouttime,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.newAttendance,
                                                            "clockouttime",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "newAttendance.clockouttime",
                                                      },
                                                    }),
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Status*",
                                          "label-for": "status",
                                        },
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: "Status",
                                            rules: "required",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("b-form-select", {
                                                      attrs: {
                                                        id: "status",
                                                        options:
                                                          _vm.statusOptions,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.newAttendance
                                                            .status,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.newAttendance,
                                                            "status",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "newAttendance.status",
                                                      },
                                                    }),
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: "Comment*",
                                          "label-for": "comment",
                                        },
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: "Comment",
                                            rules: "required",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("b-form-input", {
                                                      attrs: { id: "comment" },
                                                      model: {
                                                        value:
                                                          _vm.newAttendance
                                                            .comment,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.newAttendance,
                                                            "comment",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "newAttendance.comment",
                                                      },
                                                    }),
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(errors[0])
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          type: "submit",
                                          variant: "primary",
                                          disabled: _vm.loading,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.addAttendance()
                                          },
                                        },
                                      },
                                      [_vm._v(" Submit ")]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-pagination", {
                        staticClass: "my-0",
                        attrs: {
                          "total-rows": _vm.totalRows,
                          "per-page": _vm.perPage,
                          align: "center",
                          size: "sm",
                        },
                        model: {
                          value: _vm.currentPage,
                          callback: function ($$v) {
                            _vm.currentPage = $$v
                          },
                          expression: "currentPage",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("b-form-group", [
                    _vm._v(
                      " Showing " +
                        _vm._s(
                          _vm.totalRows > 0
                            ? _vm.perPage * (_vm.currentPage - 1) + 1
                            : 0
                        ) +
                        " to " +
                        _vm._s(
                          _vm.totalRows > 0
                            ? Math.min(
                                _vm.perPage * _vm.currentPage,
                                _vm.totalRows
                              )
                            : 0
                        ) +
                        " of " +
                        _vm._s(_vm.totalRows > 0 ? _vm.totalRows : 0) +
                        " entries "
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }